import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol viewBox=\"0 0 20 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lock\"><path d=\"m4 9v-3c0-3.3137085 2.6862915-6 6-6s6 2.6862915 6 6v3h1c1.6568542 0 3 1.3431458 3 3v7c0 1.6568542-1.3431458 3-3 3h-14c-1.65685425 0-3-1.3431458-3-3v-7c0-1.6568542 1.34314575-3 3-3zm2 0h8v-3c0-2.209139-1.790861-4-4-4s-4 1.790861-4 4zm-3 2c-.55228475 0-1 .4477153-1 1v7c0 .5522847.44771525 1 1 1h14c.5522847 0 1-.4477153 1-1v-7c0-.5522847-.4477153-1-1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol